import { useTranslations } from 'next-intl';

import { Button } from '@/components/button';

import Icons from '../Icons';

import NotificationBadge from './NotificationBadge';

interface NotificationTitleProps {
  count: number;
  markAllAsViewed: VoidFunction;
}

const NotificationTitle: React.FC<NotificationTitleProps> = ({ count, markAllAsViewed }: NotificationTitleProps) => {
  const t = useTranslations('layout.notifications');

  return (
    <div className="flex items-center justify-between px-4 py-3 bg-surface-secondary border-b border-border-primary rounded-t-lg">
      <div className="flex items-center gap-1">
        {/* leading to compensate button height 28px (avoid jumping when button is disappeared) */}
        <p className="font-medium text-text-primary leading-7">{t('title')}</p>
        <NotificationBadge count={count} />
      </div>
      {count > 0 && (
        <Button variant="transparent" size="small" leadingIcon={<Icons.MarkAllAsRead />} className="-mr-2" onClick={markAllAsViewed}>
          {t('markAllAsRead')}
        </Button>
      )}
    </div>
  );
};

export default NotificationTitle;
